import type { Railing } from "building-types/settings/railingTypes";
import { isFloat64Array } from "common/utils/float64Array";
import {
  polyLine2Copy,
  polyLine2MergeCoincidentVertices,
  polyLine2Move,
  polyLine2ReflectOverYAxis,
} from "geom/polyLine2";
import type { PolyLine2 } from "geom/polyLine2Types";

export function railingHasPath(railing: Partial<Railing> | undefined | null): railing is { path: PolyLine2 } {
  /**
   * The isFloat64Array check is necessary because this function recevies
   * an improperly formed railing path, as shown in the following error:
   * https://higharc.sentry.io/issues/6675636166
   * This is a symptomatic fix and the underlying issue is still unknown.
   */
  return !!railing?.path && Object.keys(railing.path).length > 0 && isFloat64Array(railing.path);
}

export function railingGetCleanPath(railing: Railing): PolyLine2 | null {
  if (!railingHasPath(railing)) {
    return null;
  }
  return polyLine2MergeCoincidentVertices(railing.path as PolyLine2, 0.001);
}

export function railingMirror(originalPath: PolyLine2, mirror: boolean, mirrorTranslationX: number): PolyLine2 | null {
  if (!originalPath) {
    return null;
  }
  let path = polyLine2Copy(originalPath);
  if (mirror) {
    path = polyLine2ReflectOverYAxis(polyLine2Copy(path));
    polyLine2Move(path, mirrorTranslationX, 0);
  }
  return path;
}
